export const MEDIA_DESKTOP = 992;
